import _extends from "@babel/runtime/helpers/extends";
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import ButtonGroup from '@atlaskit/button/button-group';
import Button from '@atlaskit/button/standard-button';
import DropdownMenu, { DropdownItem, DropdownItemGroup } from '@atlaskit/dropdown-menu';
import MoreIcon from '@atlaskit/icon/core/migration/show-more-horizontal--more';
import { Action } from './Action';
import { gs, mq } from '../../common/utils';
import { di } from 'react-magnetic-di';

// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
const wrapperStyles = mq({
  display: 'flex',
  marginTop: [gs(2), 0]
});
const buttonStyles = css({
  height: 'auto'
});

// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
const actionsWrapperStyles = {
  marginLeft: gs(0.5)
};
export const ActionList = ({
  items
}) => {
  const actionsToShow = items.slice(0, 2);
  const actionsToList = items.slice(2, items.length);
  return jsx("div", {
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    css: wrapperStyles
  }, jsx(ButtonGroup, null, actionsToShow.map(action => jsx(Action, _extends({
    key: action.id
  }, action)))), actionsToList.length ?
  // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
  jsx("div", {
    css: actionsWrapperStyles
  }, jsx(DropdownMenu, {
    trigger: ({
      triggerRef,
      ...props
    }) => jsx(Button, _extends({}, props, {
      iconBefore: jsx(MoreIcon, {
        label: "more",
        color: "currentColor",
        spacing: "spacious"
      }),
      ref: triggerRef,
      css: buttonStyles,
      testId: "dropdown-trigger"
    })),
    placement: "right-start"
  }, jsx(DropdownItemGroup, {
    testId: "dropdown-menu"
  }, actionsToList.map(actionToList => jsx(DropdownItem, {
    key: actionToList.id
  }, actionToList.text))))) : null);
};